import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialog, UitkDialogContent, UitkDialogFooter, UitkFullscreenDialog } from 'uitk-react-dialog';
import { UitkHeading } from 'uitk-react-text';

export interface InfoDialogProps {
  closeA11yLabel?: string;
  info: string;
  onClose: () => void;
  title?: string;
  useMiniDialog?: boolean;
  buttonLabelClose?: string;
}

export const InfoDialog: React.FunctionComponent<InfoDialogProps> = ({
  closeA11yLabel,
  info,
  onClose,
  title,
  useMiniDialog,
  buttonLabelClose
}) => {
  const { formatText } = useLocalization();
  const closeLabel = closeA11yLabel || formatText('hotels.infosite.rateInfoDialog.cancelButton.a11yLabel');

  const toolBarAttributes = {
    header: title,
    iconLabel: closeLabel,
    type: ToolbarType.CLOSE
  };

  const dialogProps = {
    dialogShow: true
  };

  if (useMiniDialog) {
    return (
      <UitkDialog>
        <UitkDialogContent>
          <UitkHeading level={1} size={500}>
            {title}
          </UitkHeading>
          <p className="pwa-theme--grey-700">{info}</p>
        </UitkDialogContent>
        <UitkDialogFooter
          buttonOne={{
            onClick: onClose,
            text: buttonLabelClose || formatText('close') || 'Close',
            type: 'tertiary'
          }}
        />
      </UitkDialog>
    );
  }

  return (
    <UitkFullscreenDialog {...dialogProps}>
      <UitkToolbar {...toolBarAttributes} className="dialog__topbar" action={onClose} />
      <section
        className="dialog__body smooth-scroll-container room-dialog__wrapper all-x-padding-six all-t-padding-six"
        dangerouslySetInnerHTML={{ __html: info }}
      />
    </UitkFullscreenDialog>
  );
};

InfoDialog.displayName = 'InfoDialog';
